import LanguagesConfig from './config.json' assert { type: 'json' }; // This server/translations/config.json is where we configure our supported languages 

export const LanguageLocales = LanguagesConfig['supported_languages']; // converts from JSON to JS object on importation

// This is our global default for all users ... but we could potentially override it if we were to add an org-level default in tbl_org_config -- for example, a French org might want an org-level default of French
export const DEFAULT_LOCALE_CODE_PREFERENCE = LanguagesConfig['default_language_locale'];

// Helper function. Takes a locale as its only argument (e.g. "en-us") and returns the associated language name (e.g. "English"), or false for an unmapped locale.
export const LocaleToLanguageMapper = (locale) => {
  let language = '';
  for (const llObj of LanguageLocales) {
    if (llObj.locale === locale) {
      language = llObj.value;
      break;
    }
  }
  return language.length ? language : false;
}